import { render } from "./LwEmpty.vue?vue&type=template&id=9bfc867a&scoped=true"
import script from "./LwEmpty.vue?vue&type=script&lang=js"
export * from "./LwEmpty.vue?vue&type=script&lang=js"

import "./LwEmpty.vue?vue&type=style&index=0&id=9bfc867a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfc867a"]])

export default __exports__